import { watchlistSelectorTranslationsDe, watchlistSelectorTranslationsEn, watchlistSelectorTranslationsEs, watchlistSelectorTranslationsFr, watchlistSelectorTranslationsIt, watchlistSelectorTranslationsNl } from '../watchlist-selector/index.js';
import { watchlistPositionAddTranslationsDe, watchlistPositionAddTranslationsEn, watchlistPositionAddTranslationsEs, watchlistPositionAddTranslationsFr, watchlistPositionAddTranslationsIt, watchlistPositionAddTranslationsNl } from '../watchlist-position-add/index.js';
import { watchlistPositionListTranslationsDe, watchlistPositionListTranslationsEn, watchlistPositionListTranslationsEs, watchlistPositionListTranslationsFr, watchlistPositionListTranslationsIt, watchlistPositionListTranslationsNl } from '../watchlist-position-list/index.js';
import { watchlistPositionDeleteTranslationsDe, watchlistPositionDeleteTranslationsEn, watchlistPositionDeleteTranslationsEs, watchlistPositionDeleteTranslationsFr, watchlistPositionDeleteTranslationsIt, watchlistPositionDeleteTranslationsNl } from '../watchlist-position-delete/index.js';
import { watchlistCreateTranslationsDe, watchlistCreateTranslationsEn, watchlistCreateTranslationsEs, watchlistCreateTranslationsFr, watchlistCreateTranslationsIt, watchlistCreateTranslationsNl } from '../watchlist-create/index.js';
import { watchlistDeleteTranslationsDe, watchlistDeleteTranslationsEn, watchlistDeleteTranslationsEs, watchlistDeleteTranslationsFr, watchlistDeleteTranslationsIt, watchlistDeleteTranslationsNl } from '../watchlist-delete/index.js';
import { watchlistEditTranslationsDe, watchlistEditTranslationsEn, watchlistEditTranslationsEs, watchlistEditTranslationsFr, watchlistEditTranslationsIt, watchlistEditTranslationsNl } from '../watchlist-edit/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';

const watchlistTranslationsDe = {
  ...watchlistSelectorTranslationsDe,
  ...watchlistPositionAddTranslationsDe,
  ...watchlistPositionListTranslationsDe,
  ...watchlistPositionDeleteTranslationsDe,
  ...watchlistCreateTranslationsDe,
  ...watchlistDeleteTranslationsDe,
  ...watchlistEditTranslationsDe,
  ...localizationSupportTranslationsDe,
  ...de
};
const watchlistTranslationsEn = {
  ...watchlistSelectorTranslationsEn,
  ...watchlistPositionAddTranslationsEn,
  ...watchlistPositionListTranslationsEn,
  ...watchlistPositionDeleteTranslationsEn,
  ...watchlistCreateTranslationsEn,
  ...watchlistDeleteTranslationsEn,
  ...watchlistEditTranslationsEn,
  ...localizationSupportTranslationsEn,
  ...en
};
const watchlistTranslationsEs = {
  ...watchlistSelectorTranslationsEs,
  ...watchlistPositionAddTranslationsEs,
  ...watchlistPositionListTranslationsEs,
  ...watchlistPositionDeleteTranslationsEs,
  ...watchlistCreateTranslationsEs,
  ...watchlistDeleteTranslationsEs,
  ...watchlistEditTranslationsEs,
  ...localizationSupportTranslationsEs,
  ...es
};
const watchlistTranslationsFr = {
  ...watchlistSelectorTranslationsFr,
  ...watchlistPositionAddTranslationsFr,
  ...watchlistPositionListTranslationsFr,
  ...watchlistPositionDeleteTranslationsFr,
  ...watchlistCreateTranslationsFr,
  ...watchlistDeleteTranslationsFr,
  ...watchlistEditTranslationsFr,
  ...localizationSupportTranslationsFr,
  ...fr
};
const watchlistTranslationsIt = {
  ...watchlistSelectorTranslationsIt,
  ...watchlistPositionAddTranslationsIt,
  ...watchlistPositionListTranslationsIt,
  ...watchlistPositionDeleteTranslationsIt,
  ...watchlistCreateTranslationsIt,
  ...watchlistDeleteTranslationsIt,
  ...watchlistEditTranslationsIt,
  ...localizationSupportTranslationsIt,
  ...it
};
const watchlistTranslationsNl = {
  ...watchlistSelectorTranslationsNl,
  ...watchlistPositionAddTranslationsNl,
  ...watchlistPositionListTranslationsNl,
  ...watchlistPositionDeleteTranslationsNl,
  ...watchlistCreateTranslationsNl,
  ...watchlistDeleteTranslationsNl,
  ...watchlistEditTranslationsNl,
  ...localizationSupportTranslationsNl,
  ...nl
};
const watchlistTranslationsBundle = {
  de: watchlistTranslationsDe,
  en: watchlistTranslationsEn,
  es: watchlistTranslationsEs,
  fr: watchlistTranslationsFr,
  it: watchlistTranslationsIt,
  nl: watchlistTranslationsNl
};

export { watchlistTranslationsBundle, watchlistTranslationsDe, watchlistTranslationsEn, watchlistTranslationsEs, watchlistTranslationsFr, watchlistTranslationsIt, watchlistTranslationsNl };
